import { useQuery } from '@tanstack/react-query'
import { getUniQueryTemplate } from 'src/pages/files/query-templates'
import { useNodeApi } from 'src/utils/api-provider'
import notify from 'src/utils/notify'

const FIVE_MINUTES = 300000

export function useUniDataForFiles(nodeName: string) {
  const { urqlClient } = useNodeApi()

  const { data } = useQuery({
    queryKey: ['getUniDataForFiles', nodeName],
    queryFn: async () => {
      const result = await urqlClient!.query(getUniQueryTemplate, {}).toPromise()
      if (result?.error) {
        throw new Error(result?.error?.message)
      }
      const uniInfo = result?.data?.getVendia_UniInfo

      if (uniInfo?.nodes) {
        const { nodes } = result.data.getVendia_UniInfo
        const currentNode = nodes.find((n: any) => n.name === nodeName)
        const uploadFileTempCreds = currentNode?.temporaryCredentials?.uploadFile

        return {
          nodes,
          currentNode,
          uploadFileTempCreds,
        }
      } else {
        notify.error('Error fetching Uni')
        console.error(result)
      }
    },
    enabled: Boolean(urqlClient),
    staleTime: FIVE_MINUTES,
  })

  return (
    data ?? {
      nodes: [],
      currentNode: undefined,
      uploadFileTempCreds: undefined,
    }
  )
}
